module.exports = __webpack_public_path__ + "img/waiting.a875b1cb.png";